/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { forgotpassword } from "../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

import logo from "assets/img/logo-white.png";
class ForgotPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHidden: true,
      email: "",
      password: "",
      _notificationSystem: null,
      /// Login
      emailLogin: "",
      emailErrorLogin: null,
      passwordLogin: "",
      passwordErrorLogin: null,
      userinfo: "",
    };
    this.handleClick = this.handleClick.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleChange = this.handleChange.bind(this);
  
  }
  componentDidMount() {
    if (localStorage.getItem("user")) {
      window.location.href = "/admin/dashboard";
    } else {
      this.setState({ _notificationSystem: this.refs.notificationSystem });
      setTimeout(
        function () {
          this.setState({ cardHidden: false });
        }.bind(this),
        700
      );
    }
  }
  
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Authentication failed</b> - Please check email.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Authenticated</b> - We have e-mailed your password reset link!.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5,
    });
  }
  handleLoginEmail(event) {
    this.setState({
      emailLogin: event.target.value,
    });
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(event.target.value) === false
      ? this.setState({
          emailErrorLogin: (
            <small className="text-danger">
              Email is required and format should be <i>john@doe.com</i>.
            </small>
          ),
        })
      : this.setState({ emailErrorLogin: null });
  }
  handleLoginPassword(event) {
    this.setState({
      passwordLogin: event.target.value,
    });
    event.target.value.length < 6
      ? this.setState({
          passwordErrorLogin: (
            <small className="text-danger">
              You must enter a password of at least 6 characters.
            </small>
          ),
        })
      : this.setState({ passwordErrorLogin: null });
  }
  handleForgotSubmit() {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let error = false;
    if (re.test(this.state.emailLogin) === false) {
      error = true;
      this.setState({
        emailErrorLogin: (
          <small className="text-danger">
            Email is required and format should be <i>john@doe.com</i>.
          </small>
        ),
      });
    } else {
      this.setState({ emailErrorLogin: null });
    }

    

    if (!error) {
        forgotpassword(this.state.emailLogin).then(
        (data) => {
          if (data.success == true) {
            var cus_data = data.data;
            // if(cus_data.length > 0)
            // {
            this.handleSuccess("bl");

            
            this.setState({
              userinfo: "Reset password link sent. Please check your email",
            });
            // }
          } else {
            this.setState({
              userinfo: "User Not Authenticated",
            });
            this.handleClick("bl");
          }
        }
      ).catch(()=>{
        this.handleNetworkError('bl')
      })
    }
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  render() {
    return (
      <div>
        <Grid>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img src={logo} alt="react-logo" width="200" />
          </div>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={4} sm={6} mdOffset={4} smOffset={3}>
              <form>
                <Card
                  textCenter
                  title="Forgot Password Form"
                  content={
                    <div>
                      <FormGroup>
                        <ControlLabel>
                          Email : <span className="star">*</span>
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="email"
                          onChange={(event) => this.handleLoginEmail(event)}
                        />
                        {this.state.emailErrorLogin}
                      </FormGroup>
                     
                      <div className="category">
                        <span className="star">*</span> Required fields
                      </div>
                      <br></br>
                      <div>
                        {this.state.userinfo.length > 0 ? (
                          <p>
                            {" "}
                            {this.state.userinfo == "User Not Authenticated" ? (
                              <div className="category ">
                                {this.state.userinfo}{" "}
                                <i
                                  style={{ color: "red" }}
                                  className="fa fa-times"
                                >
                                  {" "}
                                </i>{" "}
                              </div>
                            ) : (
                              <div className="category">
                                {this.state.userinfo}
                                <i
                                  style={{ color: "green" }}
                                  className="fa fa-check"
                                >
                                  {" "}
                                </i>{" "}
                              </div>
                            )}{" "}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  }
                  ftTextCenter
                  legend={
                    <Button
                      bsStyle="default"
                      fill
                      wd
                      onClick={this.handleForgotSubmit.bind(this)}
                    >
                      Forgot Password
                    </Button>
                  }
                />
              </form>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ForgotPage;
